///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const AdminIcon = ({
  height,
  fill,
  title = messages.admin.defaultMessage,
  width
}) => (
  <svg
    aria-labelledby="admin-icon"
    height={height}
    viewBox="0 0 50 50"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id="admin-icon">{title}</title>
    <path
      fill={fill}
      d="M5 32v17h30l3-2c4-3 7-9 7-15v-1l-9-4c-1-4-5-7-9-8a10 10 0 10-12 0C9 20 5 26 5 32zm38 1c0 5-3 10-7 13l-1 1-1-1c-4-3-7-8-7-13l8-4 8 4zM13 11a8 8 0 1116 0 8 8 0 01-16 0zm5 10h6c4 0 8 3 10 6l-9 4v1c0 6 3 11 7 15H7V32c0-6 5-11 11-11z"
    />
    <path fill={fill} d="M36 33h-2v3h-3v2h3v3h2v-3h3v-2h-3z" />
  </svg>
);

export default AdminIcon;
